import React from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/latestApprovalsActions';
import initialState from '../../reducers/initialState';
import HomePageTable from './HomePageTable';
import HOME_PAGE from '../../constants/homePage';
import utils from '../../lib/utils';
import { preprocessTableEntries } from "../../lib/homepageUtils";


export class LatestApprovals extends React.Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      latestApprovalsQuery: initialState.latestApprovalsQuery
    };
    this.sendQuery();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPartner &&
        this.props.selectedPartner !== prevProps.selectedPartner)
    {
      this.sendQuery(this.props.selectedPartner);
    }
  }

  sendQuery(partner = this.props.selectedPartner, page = 1) {
    const query = this.state.latestApprovalsQuery;
    this.props.actions.fetchLatestApprovals(
      {
        start_date: query.startDate.format('YYYY-MM-DD'),
        end_date: query.endDate.format('YYYY-MM-DD'),
        new_or_renewal: query.newOrRenewal,
        stage_name: query.stageName,
        q: query.searchParam,
        sort: query.sort,
        order: query.order,
        page: page,
        hits_per_page: 15,
        ...partner
      }
    );
  }

  render() {
    const approvals = preprocessTableEntries(this.props.latestApprovals, 'date_received');

    return (
      <HomePageTable
        dataType="pipeline"
        content={approvals}
        contentError={this.props.latestApprovalsError}
        title="Open Approvals"
        noDataMessage="You have no current open approvals."
        isAdmin={this.props.isAdmin}
        moreInfoMessage={HOME_PAGE.pipelineMoreInfoMessage}
      />
    );
  }
}

function mapStateToProps(state){
  return {
    latestApprovals: state.latestApprovals,
    latestApprovalsError: state.latestApprovalsError,
    selectedPartner: state.partner.selected,
    isAdmin: state.user && utils.isAdmin(state.user.role)
  };
}

function mapDispatchToProps(dispatch){
  return{
    actions: bindActionCreators(actions, dispatch)
  };
}

LatestApprovals.propTypes = {
  latestApprovals: PropTypes.array.isRequired,
  latestApprovalsError: PropTypes.bool.isRequired,
  selectedPartner: PropTypes.object,
  isAdmin: PropTypes.bool,
  actions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LatestApprovals);
